// P-Schein (Personenbeförderungsschein): Ablauf-Status für Warn-Chips im Portal.
//
// getLicenseExpiryStatus liefert nur dann einen Wert, wenn der Schein in weniger
// als 30 Tagen abläuft oder bereits abgelaufen ist – sonst null (kein Chip).
// Akzeptiert Firestore-Timestamps, { seconds }, Date-Objekte, ISO-Strings und ms.

export const toJsDate = (value) => {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  if (value.seconds != null) return new Date(value.seconds * 1000);
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getLicenseExpiryStatus = (licenseExpiry) => {
  const date = toJsDate(licenseExpiry);
  if (!date) return null;
  const days = Math.floor((date.getTime() - Date.now()) / 86400000);
  if (days >= 30) return null;
  if (days < 0) return { color: 'error', days, label: 'P-Schein abgelaufen' };
  if (days === 0) return { color: 'error', days, label: 'P-Schein läuft heute ab' };
  return { color: days <= 7 ? 'error' : 'warning', days, label: `P-Schein: ${days} T` };
};
